import { BrowserStorageLocalService } from 'pf-frontend-common/src/service/browser-storage-local/service';
import { WindowService } from 'pf-frontend-common/src/service/window/service';

import { EmailAlertAdditionalParamsAdapter } from 'common/data/email-alert/additional-params-adapter';
import { PropertyLeadModelAdapter } from 'common/data/property-lead/model-adapter';
import { LeadEmailFormStrategyInterface } from 'common/module/lead/email/form/strategy.interface';
import { LeadEmailFormStrategyProperty } from 'common/module/lead/email/form/strategy/property';
import { EmailAlertStoreService } from 'common/service/email-alert-store/service';
import { LeadEmailFormContactService } from 'common/service/lead-email-form-contact/service';
import { PropertyLeadStoreService } from 'common/service/property-lead-store/service';
import { UserAuthenticationService } from 'common/service/user-authentication/service';

export function LeadEmailFormStrategyPropertyFactory(): LeadEmailFormStrategyInterface {
  return new LeadEmailFormStrategyProperty(
    PropertyLeadStoreService(),
    new PropertyLeadModelAdapter(),
    WindowService(),
    EmailAlertStoreService(),
    new EmailAlertAdditionalParamsAdapter(),
    BrowserStorageLocalService(),
    UserAuthenticationService(),
    LeadEmailFormContactService()
  );
}
